import React, { useState } from 'react';
import { fetchShippingHolidays } from '../services/api';
import { EditDialog, Field, ListCard, PageTitle, WriteOffNote, useRows, useSave, useWriteLive } from '../components/StaffList';

/**
 * Tools & Lists > Shipping Holidays: the days the checkout delivery calendar closes, in full or for
 * some services (Azure exit WS8). Reads sql01.DaysClosed. Saving is off until ws8_shipping_holidays_live.
 */

const TYPES = {
  1: 'No Deliveries (Closed)',
  2: 'Air Only - No Ground or Home Deliveries',
  3: 'No 2Day Deliveries',
  4: 'Overnight Air Deliveries Only',
  5: 'No 2Day Ground Deliveries',
  6: 'No Commercial Ground Deliveries',
  7: 'No Overnight Deliveries',
};
const typeList = Object.entries(TYPES);
const showDate = (ymd) => { const [y, m, d] = ymd.split('-'); return `${m}/${d}/${y}`; };

export default function ShippingHolidays() {
  const live = useWriteLive('ws8_shipping_holidays');
  const [from, setFrom] = useState('');
  const [to, setTo] = useState('');
  const [type, setType] = useState('');
  const [adding, setAdding] = useState(null);
  const { rows, error, reload } = useRows(() => fetchShippingHolidays({ from, to, type }), [from, to, type]);
  const { save, saving, error: saveError, setError } = useSave(reload);

  const add = async () => {
    if (!adding.date) return setError('Pick a date.');
    if (await save('shipping_holiday_save', adding)) setAdding(null);
    return null;
  };

  return (
    <div>
      <PageTitle>Shipping Holidays</PageTitle>
      <WriteOffNote live={live} />
      <div className="port-filters">
        <input type="date" className="form-input" style={{ width: 'auto' }} aria-label="Start date" value={from} onChange={(e) => setFrom(e.target.value)} />
        <input type="date" className="form-input" style={{ width: 'auto' }} aria-label="End date" value={to} onChange={(e) => setTo(e.target.value)} />
        <select className="form-select" aria-label="Type" value={type} onChange={(e) => setType(e.target.value)}>
          <option value="">All</option>
          {typeList.map(([v, l]) => <option key={v} value={v}>{l}</option>)}
        </select>
        <button type="button" className="btn btn-primary" disabled={!live} onClick={() => { setError(null); setAdding({ date: '', type: 1 }); }}>Add Shipping Holiday</button>
      </div>
      <ListCard title="Closed days" rows={rows} error={error} empty="No closed days.">
        <table className="trans-table">
          <thead><tr><th>Date</th><th>Type</th><th aria-label="Actions" /></tr></thead>
          <tbody>
            {(rows || []).map((r) => (
              <tr key={r.date}>
                <td>{showDate(r.date)}</td>
                <td>{TYPES[r.type] || ''}</td>
                <td className="staff-actions">
                  <button type="button" className="btn btn-ghost" disabled={!live || saving} onClick={() => save('shipping_holiday_delete', { date: r.date })}>Delete</button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </ListCard>
      {!adding && saveError && <div className="staff-msg staff-msg-error">{saveError}</div>}
      {adding && (
        <EditDialog title="New Shipping Holiday" live={live} saving={saving} error={saveError} onClose={() => setAdding(null)} onSave={add}>
          <Field label="Date"><input type="date" className="form-input" value={adding.date} onChange={(e) => setAdding({ ...adding, date: e.target.value })} /></Field>
          <Field label="Type">
            <select className="form-select" value={adding.type} onChange={(e) => setAdding({ ...adding, type: parseInt(e.target.value, 10) })}>
              {typeList.map(([v, l]) => <option key={v} value={v}>{l}</option>)}
            </select>
          </Field>
        </EditDialog>
      )}
    </div>
  );
}
